var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-container"},[(_vm.$vuetify.breakpoint.mdAndUp)?_c('v-btn',{staticClass:"mr-2 white--text",attrs:{"elevation":"0","color":"transparent"},on:{"click":function($event){_vm.ui.show = !_vm.ui.show}}},[_c('small',[_vm._v(" Productos ")]),_c('v-icon',{staticClass:"white--text"},[_vm._v(" mdi-chevron-down ")])],1):_vm._e(),(_vm.ui.show)?_c('div',{staticClass:"menu-content elevation-8 animate__animated animate__fadeIn animate__faster"},_vm._l((_vm.getParentCategories),function(category1,key1){return _c('div',{class:[
				'option',
				'd-flex',
				category1.categories.length
					? 'justify-space-between'
					: 'justify-end' ]},[(category1.categories.length)?[_c('v-icon',{staticClass:"white--text"},[_vm._v(" mdi-chevron-left ")]),_c('div',{class:[
						'menu',
						'elevation-8',
						'animate__animated',
						'animate__fadeIn',
						'animate__faster',
						_vm.startFormTop(_vm.getParentCategories.length, key1)
							? 'menu-from-top'
							: 'menu-from-bottom' ]},_vm._l((category1.categories),function(category2,key2){return _c('div',{class:[
							'option',
							'd-flex',
							category2.categories.length
								? 'justify-space-between'
								: 'justify-end' ]},[(category2.categories.length)?[_c('v-icon',{staticClass:"white--text"},[_vm._v(" mdi-chevron-left ")]),_c('div',{class:[
									'menu',
									'elevation-8',
									'animate__animated',
									'animate__fadeIn',
									'animate__faster',
									_vm.startFormTop(
										category2.categories.length,
										key2
									)
										? 'menu-from-top'
										: 'menu-from-bottom' ]},_vm._l((category2.categories),function(category2){return _c('div',{class:[
										'option',
										'd-flex',
										category2.categories.length
											? 'justify-space-between'
											: 'justify-end' ]},[_vm._v(" "+_vm._s(category2.name)+" ")])}),0)]:_vm._e(),_vm._v(" "+_vm._s(category2.name)+" ")],2)}),0)]:_vm._e(),_vm._v(" "+_vm._s(category1.name)+" ")],2)}),0):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }